import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApiClientDsrMultiBrandService } from 'src/app/api/dsr/api-client-dsr-multi-brand.service';
import { CreateBrandRequest, DsrBrandBase, DsrBrandDetails } from 'src/app/api/models/dsr/dsr-multi-brand.interface';
import { JsonPatchDocument } from 'src/app/shared/models/json-patch.interface';
import { LoggerService } from 'src/app/logger/logger.service';
import { DsrMultiBrandQuery } from '../state/dsr-multi-brand.query';

@Injectable({
    providedIn: 'root'
})
export class DsrMultiBrandService {

    private readonly loggerName = 'DsrMultiBrandService';

    constructor(
        private loggerService: LoggerService,
        private apiClientDsrMultiBrandService: ApiClientDsrMultiBrandService,
        private dsrMultiBrandQuery: DsrMultiBrandQuery,
    ) { }

    initBrands(): Observable<void> {
        return this.apiClientDsrMultiBrandService.getBrandsShallow().pipe(
            tap(response => this.dsrMultiBrandQuery.setBrands(response.brands)),
            tap(() => this.loggerService.info(this.loggerName, ': init()')),
            tap(() => this.dsrMultiBrandQuery.setLoading(false)),
            map(() => void 0)
        );
    }

    createBrand(request: CreateBrandRequest): Observable<DsrBrandBase> {
        return this.apiClientDsrMultiBrandService.createBrand(request).pipe(
            tap(newBrand => this.setBrandInStore(newBrand)),
            tap(() => this.loggerService.info(this.loggerName, 'create brand'))
        );
    }

    setBrandInStore(brand: DsrBrandBase): void {
        const current = this.dsrMultiBrandQuery.getBrands()();
        this.dsrMultiBrandQuery.setBrands([...current, brand]);
    }   

    getBrandDetails(brandId: string): Observable<DsrBrandDetails> {
        return this.apiClientDsrMultiBrandService.getBrandDetails(brandId);
    }

    patchBrand(brandId: string, patch: JsonPatchDocument): Observable<DsrBrandBase> {
        return this.apiClientDsrMultiBrandService.patchBrand(brandId, patch).pipe(
            tap(updated => this.updateBrandInStore(updated)),
        );
    }

    private updateBrandInStore(updated: DsrBrandBase): void {
        const current = this.dsrMultiBrandQuery.getBrands()();
        const next = current.map(b => b.id === updated.id ? updated : b);
        this.dsrMultiBrandQuery.setBrands(next);
    }
    
    uploadBrandLogo(brandId: string, file: File): Observable<{ url: string }> {
        return this.apiClientDsrMultiBrandService.uploadBrandLogo(brandId, file).pipe(
            tap(response => this.dsrMultiBrandQuery.updateBrandLogoUrl(brandId, response.url))
        );
    }
}
